import { useTranslation } from "react-i18next";

export const AuthorityRibbon = () => {
  const { t } = useTranslation();
  const items = t("authority", { returnObjects: true });
  const doubled = [...items, ...items];
  return (
    <section data-testid="authority-section" className="border-y border-[#E4E2DA] bg-[#EFEDE6] overflow-hidden">
      <div className="py-8 relative">
        <div className="marquee-track flex gap-16 whitespace-nowrap w-max">
          {doubled.map((label, i) => (
            <div key={`${label}-${i}`} data-testid={`authority-item-${i}`} className="flex items-center gap-16">
              <span className="overline text-[#3E5239]">{label}</span>
              <span className="inline-block w-1.5 h-1.5 bg-[#A7CA99] rotate-45" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
